export default __webpack_public_path__ + "static/media/hot-coffee.8e169139.webp";